import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class CommonService {

    private guest = false;
    private registered = false;
    private canUseTouch = false;

    private unauthorizedSubject = new Subject<void>();
    unauthorizedSubject$ = this.unauthorizedSubject.asObservable();

    private expiredTokenSubject = new Subject<void>();
    expiredTokenSubject$ = this.expiredTokenSubject.asObservable();

    private pushPopUpdateSuccessSubject = new Subject<void>();
    pushPopUpdateSuccessSubject$ = this.pushPopUpdateSuccessSubject.asObservable();

    setUnauthorized(){
        this.unauthorizedSubject.next();
    }

    setExpiredToken() {
        this.expiredTokenSubject.next();
    }

    setPushPopUpdateSuccess() {
        this.pushPopUpdateSuccessSubject.next();
    }

    setCanUseTouch(value: boolean) {
        this.canUseTouch = value;
    }

    getCanUseTouch(): boolean {
        return this.canUseTouch
    }

    setInitialState(isRegistered) {
        if(isRegistered) {
            this.registered = true;
        } else {
            this.guest = true;
        }
    }

    isRegistered() {
        return this.registered;
    }

    isGuest() {
        return this.guest;
    }

}

